import { Button, Col, Form, Input, Layout, Row, Space, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';

interface EnterpriseSelectComponentProps {
  data?: any[];
  selectEnterprise: (enterpriseId: number) => void;
  searchEnterprise: (input: any) => void;
  moveToCreatePage: () => void;
}

function EnterpriseSelectComponent({
  data,
  selectEnterprise,
  searchEnterprise,
  moveToCreatePage,
}: EnterpriseSelectComponentProps) {
  const [form] = Form.useForm();
  const columns: ColumnsType<any> = [
    {
      title: '회사명',
      dataIndex: 'name',
    },
    {
      title: '대표명',
      dataIndex: 'representative',
    },
    {
      title: '주소',
      dataIndex: 'address',
    },
    {
      title: '',
      key: 'action',
      align: 'center',
      render: (text, record, index) => (
        <Space size="middle">
          <Button
            size="small"
            className="select-table-list-item"
            onClick={(e) => {
              e.stopPropagation();
              selectEnterprise(record.id);
            }}
          >
            선택
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Layout style={{ padding: '40px', background: '#fff' }}>
        <Row justify="center">
          <Col span={12}>
            <h1>회사 이름을 검색 후 선택 하세요.</h1>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={12}>
            <Form
              form={form}
              onFinish={searchEnterprise}
              initialValues={data}
              layout="inline"
            >
              <Form.Item
                name="name"
                label="회사명"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input
                  placeholder="회사명을 입력 하세요."
                  style={{ width: '500px' }}
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  검색
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>

        {data && (
          <Row justify="center" style={{ marginTop: '20px' }}>
            <Col span={12}>
              <Table<any>
                rowKey="id"
                columns={columns}
                dataSource={data}
                pagination={false}
              />
            </Col>
          </Row>
        )}
        <Row justify="center" style={{ marginTop: '60px' }}>
          <Col span={12}>
            <h3>회사를 찾을 수 없나요?</h3>
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: '20px' }}>
          <Col span={12}>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                moveToCreatePage();
              }}
              style={{ width: '100%' }}
              type="primary"
            >
              내 회사 등록 하기
            </Button>
          </Col>
        </Row>
      </Layout>
    </>
  );
}
export default EnterpriseSelectComponent;
